import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const DropDownContainer = styled('div')`
  width: 400px;
  height: 40px;
  cursor: pointer;
`;

export const DropDownHeader = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-radius: 4px;
  height: 100%;
  background: ${() => Palette.PrimaryGray._000};
  color: ${() => Palette.PrimaryGray._900};
  padding: 8px 15px 8px 10px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  svg {
    margin-left: auto;
    fill: ${({ isOpen }) => (!isOpen ? Palette.PrimaryGray._400 : Palette.Primary._500)};
  }
  :hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid ${() => Palette.Primary._300};
      box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
    `}
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const ListWrap = styled.div`
  padding-right: 5px;
`;

export const DropDownListContainer = styled('div')`
  cursor: default;
  background: #ffffff;

  margin-top: 0.8em;
  position: absolute;
  border: 1px solid ${Palette.PrimaryGray._200};
  filter: drop-shadow(0px 24px 18px rgba(23, 43, 77, 0.04))
    drop-shadow(0px 35px 24px rgba(23, 43, 77, 0.08));
  border-radius: 8px;
  right: 5%;
  top: 100%;
  z-index: 1000000;

  width: 400px;

  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}

  transition: all 0.2s linear;
`;

export const DropDownList = styled('ul')`
  padding: 0;
  margin: 0;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  box-sizing: border-box;
  color: ${() => Palette.PrimaryGray._700};
  padding: 8px 5px 5px 16px;
  max-height: 255px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;

export const Header = styled.h3`
  color: ${Palette.PrimaryGray._900};
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  + div {
    cursor: pointer;
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
  }
`;

export const SearchIconWrapper = styled.div`
  display: inline-flex;

  ${({ isFocusable }) =>
    isFocusable &&
    css`
      border-bottom-color: ${() => Palette.Primary._300};
    `}
  svg {
    fill: ${({ isFocusable }) => (isFocusable ? Palette.Primary._400 : Palette.PrimaryGray._400)};
  }
`;

export const SearchInputWrapper = styled.div`
  border-bottom: 1px solid ${() => Palette.PrimaryGray._200};
  width: 100%;
  position: relative;
  ${SearchIconWrapper} {
    position: absolute;
    color: blue;
    left: 25px;
    top: 40%;
    transform: translateY(-50%);
  }
`;

export const SearchInput = styled.input`
  color: ${() => Palette.PrimaryGray._900};
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  border: none;
  border-top-color: transparent;
  background: #fff;
  padding: 10px 48px;
  width: 100%;
  margin-bottom: 0;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${() => Palette.PrimaryGray._400};
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ClearSearchInputWrapper = styled.div`
  visibility: ${({ visible }) => (!visible ? 'hidden' : 'visible')};
  position: absolute;
  right: 30px;
  top: 40%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
    background: ${() => Palette.PrimaryGray._100};
  }
  &:active {
    svg {
      fill: ${() => Palette.Primary._500};
    }
    background: ${() => Palette.Primary._000};
  }
`;

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 20px 24px;
`;
